import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Mail } from "lucide-react";

export default function Footer() {
    const year = new Date().getFullYear();
    return (
        <footer className="bg-navy text-white pt-20 pb-10" data-testid="site-footer">
            <div className="max-w-7xl mx-auto px-6 lg:px-10">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 pb-16 border-b border-white/10">
                    <div className="lg:col-span-5">
                        <div className="flex items-center gap-3 mb-6">
                            <div className="w-12 h-12 border border-gold flex items-center justify-center">
                                <span className="font-serif text-gold text-2xl leading-none">MC</span>
                            </div>
                            <div>
                                <div className="font-serif text-white text-2xl">Avv. Marco Candido</div>
                                <div className="text-xs uppercase tracking-[0.25em] text-gold">Diritto del lavoro</div>
                            </div>
                        </div>
                        <p className="text-slate-400 text-sm leading-relaxed max-w-md">
                            Esperto in diritto del lavoro. Consulenza e assistenza in materia giuslavoristica per lavoratori, dirigenti e imprese.
                        </p>
                    </div>

                    <div className="lg:col-span-3">
                        <h4 className="text-[11px] uppercase tracking-[0.25em] font-bold text-gold mb-5">Sedi</h4>
                        <ul className="space-y-3 text-slate-300 text-sm">
                            <li><Link to="/avvocato-lavoro-piacenza" data-testid="footer-link-piacenza" className="hover:text-gold transition-colors">Sede di Piacenza</Link></li>
                            <li><Link to="/avvocato-lavoro-milano" data-testid="footer-link-milano" className="hover:text-gold transition-colors">Sede di Milano</Link></li>
                            <li><Link to="/avvocato-lavoro-lecce" data-testid="footer-link-lecce" className="hover:text-gold transition-colors">Sede di Lecce</Link></li>
                        </ul>
                        <h4 className="text-[11px] uppercase tracking-[0.25em] font-bold text-gold mb-5 mt-8">Studio</h4>
                        <ul className="space-y-3 text-slate-300 text-sm">
                            <li><a href="/#studio" className="hover:text-gold transition-colors">Lo Studio</a></li>
                            <li><a href="/#aree" className="hover:text-gold transition-colors">Aree di Competenza</a></li>
                            <li><a href="/#articoli" className="hover:text-gold transition-colors">Articoli</a></li>
                            <li><a href="/#contatti" className="hover:text-gold transition-colors">Contatti</a></li>
                        </ul>
                    </div>

                    <div className="lg:col-span-4">
                        <h4 className="text-[11px] uppercase tracking-[0.25em] font-bold text-gold mb-5">Sedi</h4>
                        <ul className="space-y-4 text-slate-300 text-sm">
                            <li className="flex items-start gap-3">
                                <MapPin size={16} className="text-gold mt-0.5 flex-shrink-0" />
                                <span>Corso Vittorio Emanuele II, 142/D<br />29121 Piacenza (PC) — Milano (MI) — Lecce (LE)</span>
                            </li>
                            <li className="flex items-start gap-3">
                                <Phone size={16} className="text-gold mt-1 flex-shrink-0" />
                                <span className="flex flex-wrap items-center gap-x-2">
                                    <a href="tel:0523468737" className="hover:text-gold">0523 468737</a>
                                    <span className="text-slate-500">/</span>
                                    <a href="tel:3270345624" className="hover:text-gold">327 0345624</a>
                                </span>
                            </li>
                            <li className="flex items-center gap-3">
                                <Mail size={16} className="text-gold flex-shrink-0" />
                                <a href="mailto:marco.candido@pabclex.it" className="hover:text-gold break-all">marco.candido@pabclex.it</a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
                    <div className="text-slate-500 text-xs">
                        © {year} Avv. Marco Candido — Tutti i diritti riservati
                    </div>
                    <div className="flex items-center gap-6 text-xs text-slate-500">
                        <Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-gold transition-colors">
                            Privacy & Cookie
                        </Link>
                        <span>Foro di Piacenza</span>
                        <Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-gold transition-colors text-[10px] uppercase tracking-[0.2em]">
                            Area Riservata
                        </Link>
                    </div>
                </div>
            </div>
        </footer>
    );
}
